{"browse_shop":"Răsfoiți Magazinul","go_to_shop":"Mergi la Magazin","no_orders_found":"Nu s-au găsit comenzi","title":"Comenzi"}